module.exports = __webpack_public_path__ + "static/media/2.69575d18.jpg";